import { ChangeRequestFederalTaxModel, ChangeRequestStateTax } from "./change-requests";
import { ListItem } from "./listItem";

export class FederalTax {
    id: number;
    memberID: number;
    effectiveDate: string;
    filingStatusID: number;
    claimDependents: number;
    otherIncome: number;
    deductions: number;
    extraWithholding: number;
    medicare: boolean;
    socialSecurity: boolean;
    advanceEarnedIncomeCredit: boolean;
    federalUnemploymentTax: boolean;
    createdOn: string;
    createdBy: string;
    createdFromProcess: string;
    updatedOn: string;
    updatedBy: string;
    updatedFromProcess: string;
    twoJobIndicator: boolean;
    isFedTaxExempt: boolean;
    lastUpdated: string;
    currentChangeRequestFederalTax: ChangeRequestFederalTaxModel;

    constructor() {
        this.id = 0;
        this.memberID = 0;
        this.effectiveDate = null;
        this.filingStatusID = 0;
        this.claimDependents = 0;
        this.otherIncome = 0;
        this.deductions = 0;
        this.extraWithholding = 0;
        this.medicare = false;
        this.socialSecurity = false;
        this.advanceEarnedIncomeCredit = false;
        this.federalUnemploymentTax = false;
        this.createdOn = "";
        this.createdBy = "";
        this.createdFromProcess = "";
        this.updatedOn = "";
        this.updatedBy = "";
        this.updatedFromProcess = "";
        this.twoJobIndicator = false;
        this.isFedTaxExempt = false;
        this.lastUpdated = "";
        this.currentChangeRequestFederalTax = new ChangeRequestFederalTaxModel();
    }
}

export class StateTaxBase {
    id: number;
    memberID: number;
    filingStatusID: number;
    effectiveDate: string;
    alternativeCalcID: number;
    additionalWithholding: number;
    state: string;
    createdOn: string;
    createdBy: string;
    createdFromProcess: string;
    updatedOn: string;
    updatedBy: string;
    updatedFromProcess: string;
    numberOfDependents: number;
    totalAllowances: number;
    exempt: boolean;
    nonResident: boolean;
    fullTimeStudent: boolean;
    lowIncome: boolean;
    legalResidence: string;
    spouseLegalResidence: string;
    reducedWithholding: number;
    employedOutOfState: boolean;
    stateOfEmployment: string;
    mSRRAExemption: boolean;
    additionalAllowance: number;
    countyOfResidence: string;
    countyOfEmployment: string;
    exemptionYearEffective: number;
    city: string;
    countyExemption: number;
    cityExemption: number;
    cityAdditionalWithholding: number;
    computationTax: boolean;
    pRNotExempt: boolean;
    governmentEmployee: boolean;
    countyAdditionalWithholding: number;
    jointDependents: number;
    totalExemptions: number;
    availableAllowances: number;
    georgiaAdjustmentsAllowance: number;
    isBlind: number;
    isSpouseBlind: number;
    isExempt: boolean;
    nyTotalAllowances: number;
    nycAllowances: number;
    nycAdditionalWithholding: number;
    nyYonkersAdditionalWithholding: number;
    isNYNewYorkCityResident: boolean;
    isNYYonkersResident: boolean;
    lastUpdated: string;

    constructor() {
        this.id = 0;
        this.memberID = 0;
        this.filingStatusID = 0;
        this.effectiveDate = '';
        this.alternativeCalcID = 0;
        this.additionalWithholding = 0;
        this.state = '';
        this.createdOn = '';
        this.createdBy = '';
        this.createdFromProcess = '';
        this.updatedOn = '';
        this.updatedBy = '';
        this.updatedFromProcess = '';
        this.numberOfDependents = 0;
        this.totalAllowances = 0;
        this.exempt = false;
        this.nonResident = false;
        this.fullTimeStudent = false;
        this.lowIncome = false;
        this.legalResidence = '';
        this.spouseLegalResidence = '';
        this.reducedWithholding = 0;
        this.employedOutOfState = false;
        this.stateOfEmployment = '';
        this.mSRRAExemption = false;
        this.additionalAllowance = 0;
        this.countyOfResidence = '';
        this.countyOfEmployment = '';
        this.exemptionYearEffective = 0;
        this.city = '';
        this.countyExemption = 0;
        this.cityExemption = 0;
        this.cityAdditionalWithholding = 0;
        this.computationTax = false;
        this.pRNotExempt = false;
        this.governmentEmployee = false;
        this.countyAdditionalWithholding = 0;
        this.jointDependents = 0;
        this.totalExemptions = 0;
        this.availableAllowances = 0;
        this.georgiaAdjustmentsAllowance = 0;
        this.isBlind = 0;
        this.isSpouseBlind = 0;
        this.isExempt = false;
        this.nyTotalAllowances = 0;
        this.nycAllowances = 0;
        this.nycAdditionalWithholding = 0;
        this.nyYonkersAdditionalWithholding = 0;
        this.isNYNewYorkCityResident = false;
        this.isNYYonkersResident = false;
        this.lastUpdated = '';
    }
}

export class StateTaxExtended extends StateTaxBase {
    stateTaxDetail: StateTaxDetail;
    stateTaxRequiredFields: StateTaxRequiredFields;
    isUniversalControl: boolean;
    isArizonaControl: boolean;
    isNewYorkControl: boolean;
    isPuertoRicoControl: boolean;
    noStateTax: boolean;

    constructor() {
        super();
        this.stateTaxDetail = new StateTaxDetail();
        this.stateTaxRequiredFields = new StateTaxRequiredFields();
        this.isUniversalControl = false;
        this.isArizonaControl = false;
        this.isNewYorkControl = false;
        this.isPuertoRicoControl = false;
        this.noStateTax = false;
    }
}

export class StateTaxDetail {
    mSRRAExemptionVisible: boolean;
    mSRRAExemptionText: string;
    mSRRAExemptionLabel: string;
    mSRRAExemptionLabel2: string;
    legalResidenceVisible: boolean;
    legalResidenceLabel: string;
    legalResidenceSubLabel: string;
    spouseLegalResidenceVisible: boolean;
    spouseLegalResidenceLabel: string;
    spouseLegalResidenceSubLabel: string;
    filingStatusVisible: boolean;
    filingStatusLabel: string;
    filingStatusSubLabel: string;
    filingStatuses: ListItem[];
    filingStatusVisible2: boolean;
    filingStatusLabel2: string;
    filingStatusSubLabel2: string;
    alternativeCalcVisible: boolean;
    alternativeCalcLabel: string;
    alternativeCalcSubLabel: string;
    alternativeCalcs: ListItem[];
    dependentsVisible: boolean;
    dependentsLabel: string;
    dependentsSubLabel: string;
    totalExemptionsVisible: boolean;
    totalExemptionsLabel: string;
    totalExemptionsSubLabel: string;
    totalExemptionsVisible2: boolean;
    totalExemptionsLabel2: string;
    totalExemptionsSubLabel2: string;
    totalAllowancesVisible: boolean;
    totalAllowancesLabel: string;
    totalAllowancesSubLabel: string;
    additionalAllowanceVisible: boolean;
    additionalAllowanceLabel: string;
    additionalAllowanceSubLabel: string;
    additionalAllowanceVisible2: boolean;
    additionalAllowanceLabel2: string;
    additionalAllowanceSubLabel2: string;
    additionalWithholdingVisible: boolean;
    additionalWithholdingLabel: string;
    additionalWithholdingSubLabel: string;
    countyAdditionalWithholdingVisible: boolean;
    countyAdditionalWithholdingLabel: string;
    countyAdditionalWithholdingSubLabel: string;
    county1Visible: boolean;
    county1Label: string;
    county2Visible: boolean;
    county2Label: string;
    counties: ListItem[];
    reducedWithholdingVisible: boolean;
    reducedWithholdingLabel: string;
    reducedWithholdingSubLabel: string;
    lowIncomeVisible: boolean;
    lowIncomeLabel: string;
    lowIncomeSubLabel: string;
    lowIncomeVisible2: boolean;
    lowIncomeLabel2: string;
    lowIncomeSubLabel2: string;
    exemptVisible: boolean;
    exemptLegalResidenceEnabled: boolean;
    exemptLegalResidenceText: string;
    exemptSpouseLegalResidenceEnabled: boolean;
    exemptSpouseLegalResidenceText: string;
    exemptFullTimeStudentEnabled: boolean;
    exemptFullTimeStudentText: string;
    exemptYearEffectiveEnabled: boolean;
    exemptYearEffectiveLabel: string;
    exemptStateTaxExemptFieldValue: number;
    exemptTypeEnabled: boolean;
    exemptTypes: ListItem[];
    exemptVisibleEnd: boolean;
    exemptLegalResidenceEnabledEnd: boolean;
    exemptLegalResidenceTextEnd: string;
    exemptSpouseLegalResidenceEnabledEnd: boolean;
    exemptSpouseLegalResidenceTextEnd: string;
    exemptFullTimeStudentEnabledEnd: boolean;
    exemptFullTimeStudentTextEnd: string;
    exemptYearEffectiveEnabledEnd: boolean;
    exemptYearEffectiveLabelEnd: string;
    exemptCodeEnabledEnd: boolean;
    exemptCodeLabelEnd: string;
    nonResidentVisible: boolean;
    nonResidentText: string;
    cityVisible: boolean;
    cityLabel: string;
    citySubLabel: string;
    cityAdditionalWithholdingVisible: boolean;
    cityAdditionalWithholdingLabel: string;
    cityAdditionalWithholdingSubLabel: string;
    cityExemptionVisible: boolean;
    cityExemptionLabel: string;
    cityExemptionSubLabel: string;
    computationTaxVisible: boolean;
    computationTaxText: string;
    dateOfBirthVisible: boolean;
    dateOfBirthLabel: string;
    dateOfBirthSubLabel: string;
    notExemptVisible: boolean;
    notExemptText: string;
    jointDependentsVisible: boolean;
    jointDependentsLabel: string;
    jointDependentsSubLabel: string;
    availableAllowancesVisible: boolean;
    availableAllowancesLabel: string;
    availableAllowancesSubLabel: string;
    governmentEmployeeVisible: boolean;
    governmentEmployeeText: string;
    azCheckboxesLabel: string;
    azCheckbox1: boolean;
    azCheckbox2: boolean;
    azAlternativeCalcLabel: string;
    azCheckboxExtraWithholdingText: string;
    azCheckboxExtraWithholding: boolean;
    azCheckbox2Text: string;
    gaAdjustmentsAllowanceVisible: boolean;
    gaAdjustmentsAllowanceLabel: string;
    gaAdjustmentsAllowanceSubLabel: string;
    isBlindVisible: boolean;
    isBlindLabel: string;
    isBlindSubLabel: string;
    isSpouseBlindVisible: boolean;
    isSpouseBlindLabel: string;
    isSpouseBlindSubLabel: string;
    isStudentVisible: boolean;
    isStudentLabel: string;
    isStudentSubLabel: string;
    nyIsNewYorkCityResident: boolean;
    nyIsNewYorkCityText: string;
    nyNewYorkCityTotalAllowancesVisible: boolean;
    nyNewYorkCityTotalAllowancesLabel: string;
    nyNewYorkCityTotalAllowancesSubLabel: string;
    nyNewYorkCityAdditionalWithholdingVisible: boolean;
    nyNewYorkCityAdditionalWithholdingLabel: string;
    nyNewYorkCityAdditionalWithholdingSubLabel: string;
    nyIsYonkerResident: boolean;
    nyIsYonkerResidentText: string;
    nyYonkerAdditionalWithholdingVisible: boolean;
    nyYonkerAdditionalWithholdingLabel: string;
    nyYonkerAdditionalWithholdingSubLabel: string;

    constructor() {
        this.mSRRAExemptionVisible = false;
        this.mSRRAExemptionText = '';
        this.mSRRAExemptionLabel = '';
        this.mSRRAExemptionLabel2 = '';
        this.legalResidenceVisible = false;
        this.legalResidenceLabel = '';
        this.legalResidenceSubLabel = '';
        this.spouseLegalResidenceVisible = false;
        this.spouseLegalResidenceLabel = '';
        this.spouseLegalResidenceSubLabel = '';
        this.filingStatusVisible = false;
        this.filingStatusLabel = '';
        this.filingStatusSubLabel = '';
        this.filingStatuses = new Array<ListItem>;
        this.filingStatusVisible2 = false;
        this.filingStatusLabel2 = '';
        this.filingStatusSubLabel2 = '';
        this.alternativeCalcVisible = false;
        this.alternativeCalcLabel = '';
        this.alternativeCalcSubLabel = '';
        this.alternativeCalcs = new Array<ListItem>;
        this.dependentsVisible = false;
        this.dependentsLabel = '';
        this.dependentsSubLabel = '';
        this.totalExemptionsVisible = false;
        this.totalExemptionsLabel = '';
        this.totalExemptionsSubLabel = '';
        this.totalExemptionsVisible2 = false;
        this.totalExemptionsLabel2 = '';
        this.totalExemptionsSubLabel2 = '';
        this.totalAllowancesVisible = false;
        this.totalAllowancesLabel = '';
        this.totalAllowancesSubLabel = '';
        this.additionalAllowanceVisible = false;
        this.additionalAllowanceLabel = '';
        this.additionalAllowanceSubLabel = '';
        this.additionalAllowanceVisible2 = false;
        this.additionalAllowanceLabel2 = '';
        this.additionalAllowanceSubLabel2 = '';
        this.additionalWithholdingVisible = false;
        this.additionalWithholdingLabel = '';
        this.additionalWithholdingSubLabel = '';
        this.countyAdditionalWithholdingVisible = false;
        this.countyAdditionalWithholdingLabel = '';
        this.countyAdditionalWithholdingSubLabel = '';
        this.county1Visible = false;
        this.county1Label = '';
        this.county2Visible = false;
        this.county2Label = '';
        this.counties = new Array<ListItem>;
        this.reducedWithholdingVisible = false;
        this.reducedWithholdingLabel = '';
        this.reducedWithholdingSubLabel = '';
        this.lowIncomeVisible = false;
        this.lowIncomeLabel = '';
        this.lowIncomeSubLabel = '';
        this.lowIncomeVisible2 = false;
        this.lowIncomeLabel2 = '';
        this.lowIncomeSubLabel2 = '';
        this.exemptVisible = false;
        this.exemptLegalResidenceEnabled = false;
        this.exemptLegalResidenceText = '';
        this.exemptSpouseLegalResidenceEnabled = false;
        this.exemptSpouseLegalResidenceText = '';
        this.exemptFullTimeStudentEnabled = false;
        this.exemptFullTimeStudentText = '';
        this.exemptYearEffectiveEnabled = false;
        this.exemptYearEffectiveLabel = '';
        this.exemptStateTaxExemptFieldValue = 0;
        this.exemptTypeEnabled = false;
        this.exemptTypes = new Array<ListItem>;
        this.exemptVisibleEnd = false;
        this.exemptLegalResidenceEnabledEnd = false;
        this.exemptLegalResidenceTextEnd = '';
        this.exemptSpouseLegalResidenceEnabledEnd = false;
        this.exemptSpouseLegalResidenceTextEnd = '';
        this.exemptFullTimeStudentEnabledEnd = false;
        this.exemptFullTimeStudentTextEnd = '';
        this.exemptYearEffectiveEnabledEnd = false;
        this.exemptYearEffectiveLabelEnd = '';
        this.exemptCodeEnabledEnd = false;
        this.exemptCodeLabelEnd = '';
        this.nonResidentVisible = false;
        this.nonResidentText = '';
        this.cityVisible = false;
        this.cityLabel = '';
        this.citySubLabel = '';
        this.cityAdditionalWithholdingVisible = false;
        this.cityAdditionalWithholdingLabel = '';
        this.cityAdditionalWithholdingSubLabel = '';
        this.cityExemptionVisible = false;
        this.cityExemptionLabel = '';
        this.cityExemptionSubLabel = '';
        this.computationTaxVisible = false;
        this.computationTaxText = '';
        this.dateOfBirthVisible = false;
        this.dateOfBirthLabel = '';
        this.dateOfBirthSubLabel = '';
        this.notExemptVisible = false;
        this.notExemptText = '';
        this.jointDependentsVisible = false;
        this.jointDependentsLabel = '';
        this.jointDependentsSubLabel = '';
        this.availableAllowancesVisible = false;
        this.availableAllowancesLabel = '';
        this.availableAllowancesSubLabel = '';
        this.governmentEmployeeVisible = false;
        this.governmentEmployeeText = '';
        this.azCheckboxesLabel = '';
        this.azCheckbox1 = false;
        this.azCheckbox2 = false;
        this.azAlternativeCalcLabel = '';
        this.azCheckboxExtraWithholdingText = '';
        this.azCheckboxExtraWithholding = false;
        this.azCheckbox2Text = '';
        this.gaAdjustmentsAllowanceVisible = false;
        this.gaAdjustmentsAllowanceLabel = '';
        this.gaAdjustmentsAllowanceSubLabel = '';
        this.isBlindVisible = false;
        this.isBlindLabel = '';
        this.isBlindSubLabel = '';
        this.isSpouseBlindVisible = false;
        this.isSpouseBlindLabel = '';
        this.isSpouseBlindSubLabel = '';
        this.isStudentVisible = false;
        this.isStudentLabel = '';
        this.isStudentSubLabel = '';
        this.nyIsNewYorkCityResident = false;
        this.nyIsNewYorkCityText = '';
        this.nyNewYorkCityTotalAllowancesVisible = false;
        this.nyNewYorkCityTotalAllowancesLabel = '';
        this.nyNewYorkCityTotalAllowancesSubLabel = '';
        this.nyNewYorkCityAdditionalWithholdingVisible = false;
        this.nyNewYorkCityAdditionalWithholdingLabel = '';
        this.nyNewYorkCityAdditionalWithholdingSubLabel = '';
        this.nyIsYonkerResident = false;
        this.nyIsYonkerResidentText = '';
        this.nyYonkerAdditionalWithholdingVisible = false;
        this.nyYonkerAdditionalWithholdingLabel = '';
        this.nyYonkerAdditionalWithholdingSubLabel = '';
    }
}

export class StateTaxRequiredFields {
    isFilingStatusRequired: boolean;
    filingStatusError: string;
    isAlternativeCalcRequired: boolean;
    alternativeCalcError: string;
    isExemptLegalResidenceRequired: boolean;
    exemptLegalResidenceError: string;
    countyOfResidenceRequired: boolean;
    countyOfResidenceError: string;
    countyOfEmploymentRequired: boolean;
    countyOfEmploymentError: string;
    vertexIndianaCountyJanResidenceRequired: boolean;
    vertexIndianaCountyJanResidenceError: string;
    vertexIndianaCountyJanWorkRequired: boolean;
    vertexIndianaCountyJanWorkError: string;

    constructor() {
        this.isFilingStatusRequired = false;
        this.filingStatusError = '';
        this.isAlternativeCalcRequired = false;
        this.alternativeCalcError = '';
        this.isExemptLegalResidenceRequired = false;
        this.exemptLegalResidenceError = '';
        this.countyOfResidenceRequired = false;
        this.countyOfResidenceError = '';
        this.countyOfEmploymentRequired = false;
        this.countyOfEmploymentError = '';
        this.vertexIndianaCountyJanResidenceRequired = false;
        this.vertexIndianaCountyJanResidenceError = '';
        this.vertexIndianaCountyJanWorkRequired = false;
        this.vertexIndianaCountyJanWorkError = '';
    }
}

export class StateTaxIndexModel {
    code: string;
    name: string;
    noStateTax: boolean;
    haveChangeRequest: boolean;

    constructor() {
        this.code = '';
        this.name = '';
        this.noStateTax = false;
        this.haveChangeRequest = false;
    }
}

export interface MemberStateTaxes {
    stateTaxIndexModels: StateTaxIndexModel[];
    stateTaxModels: StateTaxExtended[];
    changeRequestStateTaxModels: ChangeRequestStateTax[];
}